<template>
  <b-card :header="caption">
    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
      <template slot="options" slot-scope="row">
        <b-button title="Toggle details" variant="primary" size="sm" @click.stop="row.toggleDetails" class="mr-2">
        {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
        </b-button>
        <b-button variant="secondary" size="sm" @click="goToEdit(row.item.id)" class="mr-2">
          <i title="Edit" class="cui-pencil icons"></i>
        </b-button>
      </template>
      <template slot="row-details" slot-scope="row">

        <b-card>
          <b-col sm="4">
            <b-table striped :fields="detailsUserDataFields" stacked :items="getRowDetails(row.item)" class="text-left user-details">

            </b-table>
          </b-col>
        </b-card>

      </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
    </nav>
  </b-card>
</template>

<script>
import { globalStore } from '@/main'

export default {
  name: 'users-table',
  props: {
    caption: {
      type: String,
      default: 'Registered Users'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      fields: [
        {key: 'email'},
        {key: 'last_name', sortable: true, formatter: 'formatterFullName'},
        {key: 'zip_code'},
        {key: 'city', sortable: true},
        {key: 'created_at', sortable: true, label: "Created"},
        "options"
      ],
      currentPage: 1,
      perPage: 4,
      totalRows: 0,
      detailsUserDataFields: [
        'last_name',
        'first_name',
        'email',
        'address',
        'city',
        {key: 'zip_code', label: 'Postcode'},
        'phone',
        {key: 'administrative_region_1', label: 'adm. region 1'},
        {key: 'administrative_region_2', label: 'adm. region 2'},
      ],
      marketingDetailsUserDataFields: [
        'terms_agreement',
        'terms_agreement_text',
        'electronic_agreement',
        'electronic_agreement_text',
        'marketing_agreement',
        'marketing_agreement_text'
      ]
    }
  },
  mounted () {
    this.loadUsersData()
  },
  methods: {
    loadUsersData () {
      let cmp = this
      cmp.axios.get(globalStore.API_BASE_URL + 'users').then((response) => {
        let responseData = response.data
        if (responseData.code === 200) {
          cmp.items = responseData.data
        } else {
          alert('There was problem with fetch data from server.')
        }
      }).catch((error) => {
        console.error(error)
      })
    },
    getRowCount (items) {
      return items.length
    },
    formatterFullName (value, key, item) {
      return `${item.last_name} ${item.first_name}`
    },
    goToEdit (id) {
      this.$router.push('/promotion_users/' + id)
    },
    getRowDetails (item) {
      console.log(item)
      let ar = [];
      ar.push(item)
      return ar
    }
  }
}
</script>
